module.exports = __webpack_public_path__ + "public/images/testimonial-bottom-doodle.16e836ecdb9462f10933765049b81459.webp";